import React from "react";
import { Icon } from "@iconify/react";
import closeIcon from "@iconify/icons-mdi/close";
import '../../../styles/Auth/categoryPopup.css';
import { Typography } from "@mui/material";

const ViewServiceCategoryPopup = ({ data, onClose }) => {
    const category = data?.existingServiceCategory || data;

    return (
        <div className="category-detail-overlay">
            <div className="category-detail-modal">
                <button className="category-detail-close" onClick={onClose}>
                    <Icon icon="solar:close-circle-bold-duotone" width={32} height={32} />
                </button>

                <div className="category-detail-header">
                    <div className="category-detail-image-container">
                        <img
                            src={category?.serviceCategoryImageObject?.uri ? `${(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "")}/${category.serviceCategoryImageObject.uri.replace(/^\/+/, "")}` : "/assets/placeholder.png"}
                            alt={category.serviceCategoryName}
                            onError={(e) => { e.target.onerror = null; e.target.src = "/assets/placeholder.png"; }}
                            className="category-detail-img"
                        />
                    </div>
                    <Typography variant="h5" className="category-detail-title">
                        {category.serviceCategoryName}
                    </Typography>
                </div>

                <div className="category-detail-content">
                    {category.description && (
                        <div className="category-detail-section">
                            <label><Icon icon="solar:document-text-bold-duotone" /> Description</label>
                            <p>{category.description}</p>
                        </div>
                    )}

                    <div className="category-detail-stats">
                        <div className="stat-card">
                            <Icon icon="solar:shop-2-bold-duotone" className="stat-icon" />
                            <div className="stat-info">
                                <span className="stat-label">Status</span>
                                <span className={`stat-value ${category.isActive ? 'active' : 'inactive'}`}>
                                    {category.isActive ? 'Active' : 'Inactive'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="category-detail-footer">
                    <button className="category-detail-action-btn" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewServiceCategoryPopup;
